<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="file-text"> </b-icon>
            <div class="headerTxt mLeft">Nueva requisicion</div>
          </div>
          <div class="alignIcon bold">CÓDIGO: RQ_01</div>
        </div>

        <div class="noAlTope">
          <b-tabs>
            <b-tab
              title="Ordinario"
              lazy
              active
              v-if="$localStorageService.can('RQ_01_Req_ordinario')"
            >
              <ordinario />
            </b-tab>
            <b-tab
              title="Extraordinario"
              lazy
              v-if="$localStorageService.can('RQ_01_Req_extraordinario')"
            >
              <extraordinario />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import ordinario from "./BandejaOrdinario.vue";
import extraordinario from "./BandejaExtraordinario.vue";

export default {
  name: "NuevaRequisicion",
  components: {
    Header,
    ordinario,
    extraordinario,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>